import useAxiosPrivate from '../hooks/useAxiosPrivate';

export default function RecycleAllSelectedUsers({ user, setUsers }) {



  const axiosPrivate = useAxiosPrivate()

  //URLS

  const RECYCLEALL_URL = `/users/recycleselected`;
  const USERS_URL = `/users/`; //HERE

  //Recycle function


  const recycleSelectedUsers = async (e) => {
    e.preventDefault()

    try {
      await axiosPrivate.put(
        RECYCLEALL_URL
      )
      axiosPrivate.get(USERS_URL).then

        (function (res) {
          setUsers([...res.data]);

        });
    } catch (err) {
      console.error(err.message)
    }
  }

  return (
    <div>
      <button
        type="button"
        className="btn button-black"
        data-dismiss="modal"
        onClick={e => recycleSelectedUsers(e)}
      >Yes</button>
    </div>

  )
}